"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const utils_1 = require("../../Auth/utils");
const AuthContext_1 = require("../../Auth/AuthContext");
const CatalogsGrid_1 = __importDefault(require("../../components/Catalogs/CatalogsGrid"));
const CatalogItemsPage = () => {
    const { user } = (0, AuthContext_1.useAuth)();
    return (react_1.default.createElement("div", { className: 'container flex flex-col h-full' },
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, "Katalog-Export: Schritt 1/3")),
        (0, utils_1.isAllowed)(user, ['manage_catalog']) ? (react_1.default.createElement("div", { className: 'flex flex-col h-full' },
            react_1.default.createElement("div", { className: "md:flex md:items-center md:justify-between my-4" },
                react_1.default.createElement("div", { className: "flex-1 min-w-0 " },
                    react_1.default.createElement("h2", { className: "text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate" }, "Katalog-Export: Schritt 1/3")),
                react_1.default.createElement("div", { className: "mt-4 flex md:mt-0 md:ml-4" })),
            react_1.default.createElement(CatalogsGrid_1.default, null))) : null));
};
exports.default = CatalogItemsPage;
